import React from 'react'
import cn from 'classnames'

import styles from './Icon.module.css'

const definitions = {
  twitter: require('!raw!../images/icon-48-twitter.svg'),
  github: require('!raw!../images/icon-48-github.svg'),
  instagram: require('!raw!../images/icon-48-instagram.svg'),
  dribbble: require('!raw!../images/icon-48-dribbble.svg'),
}

export default function Icon({ type, className, ...props }) {
  const html = definitions[type]
  return (
    <div 
      dangerouslySetInnerHTML={{__html: html}} 
      className={cn(styles.base, styles[type], className)}
      {...props}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Icon.js